__turbopack_context__.v({
  "optionLabel": "VariantPicker-module__paBJFG__optionLabel",
  "optionPrice": "VariantPicker-module__paBJFG__optionPrice",
  "optionTitle": "VariantPicker-module__paBJFG__optionTitle",
  "soldOut": "VariantPicker-module__paBJFG__soldOut",
});
